import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { articles } from "@/mocks/articles";

export default function Footer() {
  const mainCategories = categories.slice(0, 7);
  const moreCategories = categories.slice(7);

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <h3 className="font-heading text-2xl font-bold text-white mb-4">
              SUPERBUY
              <br />
              SPREADSHEET
            </h3>
            <p className="text-sm text-background-300/80 leading-relaxed mb-6">
              Your ultimate resource for superbuy spreadsheet guides, product categories, QC tutorials, and safe shopping strategies.
            </p>
            <div className="flex items-center gap-3">
              {["ri-twitter-x-line", "ri-instagram-line", "ri-youtube-line", "ri-github-line"].map((icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-9 h-9 rounded-full border border-background-300/30 flex items-center justify-center text-background-300 hover:text-white hover:border-white/50 transition-colors cursor-pointer"
                  rel="nofollow"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className={`${icon} text-sm`}></i>
                  </span>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-300 mb-5">
              Quick Links
            </h4>
            <div className="space-y-2.5">
              <Link to="/" className="block text-sm text-background-300/70 hover:text-white transition-colors cursor-pointer">
                Home
              </Link>
              <Link to="/article/best-superbuy-spreadsheet-guide" className="block text-sm text-background-300/70 hover:text-white transition-colors cursor-pointer">
                Beginner Guide
              </Link>
              <Link to="/article/how-to-use-superbuy-spreadsheet" className="block text-sm text-background-300/70 hover:text-white transition-colors cursor-pointer">
                How to Use
              </Link>
              <Link to="/article/is-superbuy-spreadsheet-safe" className="block text-sm text-background-300/70 hover:text-white transition-colors cursor-pointer">
                Safety Guide
              </Link>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-300 mb-5">
              Categories
            </h4>
            <div className="space-y-2.5">
              {mainCategories.map((cat) => (
                <a
                  key={cat.slug}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-background-300/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          {/* More Categories */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-300 mb-5">
              More
            </h4>
            <div className="space-y-2.5">
              {moreCategories.map((cat) => (
                <a
                  key={cat.slug}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-background-300/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-background-300/10">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-300/50">
            &copy; {new Date().getFullYear()} Superbuy Spreadsheet Forum. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-xs text-background-300/50 hover:text-white transition-colors cursor-pointer">
              Home
            </Link>
            <Link to="/article/best-superbuy-spreadsheet-guide" className="text-xs text-background-300/50 hover:text-white transition-colors cursor-pointer">
              Guides
            </Link>
            <a href="#" className="text-xs text-background-300/50 hover:text-white transition-colors cursor-pointer">
              Privacy
            </a>
          </div>
        </div>
      </div>

      {/* Disclaimer */}
      <div className="border-t border-background-300/10">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-4">
          <p className="text-xs text-background-300/40 text-center leading-relaxed">
            This website is an independent informational resource. We are not affiliated with Superbuy. All external links to kaspreadsheet.com use <code className="text-background-300/60">rel=&quot;noopener nofollow&quot;</code>.
          </p>
        </div>
      </div>
    </footer>
  );
}